import { appStoreLenses } from 'root/src/client/logic/app/lenses'

const { viewCreatorData } = appStoreLenses

export default viewCreatorData
